define(function(require) {
    var $ = require('jquery');
    var Dialog = require('./dialog');
    var Dnd = require('../../util/dnd/dnd');

    var template = '{{#if title}}'
                    + '<div class="{{classPrefix}}-title" data-role="title">{{{title}}}</div>'
                    + '{{/if}}'
                    + '<div class="{{classPrefix}}-content" data-role="content">'
                        + '<div class="{{classPrefix}}-message" data-role="message">{{{message}}}</div>'
                    + '</div>'
                    + '{{#if hasFoot}}'
                    + '<div class="{{classPrefix}}-operation" data-role="foot">'
                        + '<div class="{{classPrefix}}-btns">'
                            + '{{#if confirmTpl}}'
                            + '<button type="button" class="u-btn u-btn-primary" data-role="confirm">'
                                +'{{{confirmTpl}}}'
                            + '</button>'
                            + '{{/if}}'
                            + '{{#if uncertainTpl}}'
                            + '<button type="button" class="u-btn u-btn-primary" data-role="uncertain">'
                                + '{{{uncertainTpl}}}'
                            + '</button>'
                            + '{{/if}}'
                            + '{{#if cancelTpl}}'
                            + '<button type="button" class="u-btn u-btn-default" data-role="cancel">'
                                + '{{{cancelTpl}}}'
                            + '</button>'
                            + '{{/if}}'
                        + '</div>'
                    + '</div>'
                    + '{{/if}}';

    var ConfirmBox = Dialog.extend({

        attrs: {
            title: '默认标题',

            confirmTpl: '确定',

            uncertainTpl: '',       // '不确定'，默认不呈现

            cancelTpl: '取消',

            message: '默认内容',

            // 是否允许拖放
            // 该项只能应用于弹窗的title区域
            dnd: true,

            effect: 'fade'
        },

        setup: function () {
            ConfirmBox.superclass.setup.call(this);

            var model = {
                classPrefix: this.get('classPrefix'),
                message: this.get('message'),
                title: this.get('title'),
                confirmTpl: this.get('confirmTpl'),
                uncertainTpl: this.get('uncertainTpl'),
                cancelTpl: this.get('cancelTpl'),
                hasFoot: this.get('confirmTpl') || this.get('cancelTpl')
            };

            this.set('content', this.compile(template, model));

            this.after('render', function() {
                if (this.get('dnd') && this.get('title')) {
                    this.dnd = new Dnd({
                        element: this.element,
                        handle: this.$('[data-role=title]')
                    });
                }
            })
        },

        destroy: function() {
            this.dnd && this.dnd.destroy();
            ConfirmBox.superclass.destroy.call(this);
        },

        _setPosition: function () {
            // 高度超过窗口的 42/50, 采用纵向轴滚动
            var $content = this.contentElement;
            if (this.element.height() > $(window).height() * 0.84) {
                $content.find('[data-role=content]').css({
                    maxHeight: $(window).height() - $content.find('[data-role=title]').outerHeight() - $content.find('[data-role=foot]').outerHeight(),
                    overflowY: 'scroll'
                });
            } else {
                $content.find('[data-role=content]').css({
                    maxHeight: 9999,
                    overflowY: 'visible'
                });
            }

            Dialog.superclass._setPosition.call(this);
        },

        events: {
            'click [data-role=confirm]': function (e) {
                e.preventDefault();
                this.trigger('confirm');
            },
            'click [data-role=uncertain]': function (e) {
                e.preventDefault();
                this.trigger('uncertain');
            },
            'click [data-role=cancel]': function (e) {
                e.preventDefault();
                this.trigger('cancel');
                this.hide();
            },
            'click [data-role=close]': function (e) {
                e.preventDefault();
                this.trigger('cancel');
                this.hide();
                ConfirmBox.superclass.hide.call(this);
            }
        },

        _onChangeMessage: function (val) {
            this.$('[data-role=message]').html(val);
        },

        _onChangeTitle: function (val) {
            this.$('[data-role=title]').html(val);
        },

        _onChangeConfirmTpl: function (val) {
            this.$('[data-role=confirm]').html(val);
        },

        _onChangeUncerainTpl: function(val) {
            this.$('[data-role=uncertain]').html(val);
        },

        _onChangeCancelTpl: function (val) {
            var $cancel = this.$('[data-role=cancel]');

            if (!val) {
                $cancel.html('').hide();
            } else {
                $cancel.html(val).show();
            }
        }

    });

    ConfirmBox.alert = function (message, callback, options) {
        var defaults = {
            message: message,
            title: '',
            cancelTpl: '',
            closeTpl: '',
            onConfirm: function () {
                callback && callback();
                this.hide();
            }
        };
        addShowingConfirms('alert');
        new ConfirmBox($.extend(null, defaults, options)).show().after('hide', function () {
            this.destroy();
            deleteShowingConfirms('alert');
        });
    };

    ConfirmBox.confirm = function (message, title, onConfirm, onCancel, options) {
        // support confirm(message, title, onConfirm, options)
        if (typeof onCancel === 'object' && !options) {
            options = onCancel;
            onCancel = undefined;
        }

        var defaults = {
            message: message,
            title: title || '确认框',
            closeTpl: '',
            onConfirm: function () {
                onConfirm && onConfirm();
                this.hide();
            },
            onCancel: function () {
                onCancel && onCancel();
                this.hide();
            }
        };
        addShowingConfirms('confirm');
        new ConfirmBox($.extend(null, defaults, options)).show().after('hide', function () {
            this.destroy();
            deleteShowingConfirms('confirm');
        });
    };

    ConfirmBox.show = function (message, callback, options) {
        var defaults = {
            message: message,
            title: '',
            confirmTpl: false,
            cancelTpl: false
        };
        addShowingConfirms('show');
        new ConfirmBox($.extend(null, defaults, options)).show().before('hide', function () {
            callback && callback();
        }).after('hide', function () {
            this.destroy();
            deleteShowingConfirms('show');
        });
    };

    ConfirmBox.hasConfirmBox = function(type) {
        return ConfirmBox[type] && ConfirmBox[type].count > 0;
    };


    // Helpers
    function addShowingConfirms(type) {
        var count = ConfirmBox[type].count || 0;
        ConfirmBox[type].count = ++count;
    }

    function deleteShowingConfirms(type) {
        var count = ConfirmBox[type].count || 0;
        if (count) {
            ConfirmBox[type].count = --count;
        }
    }

    return ConfirmBox;
});



/*****************
 ** WEBPACK FOOTER
 ** ./~/cui/ui/dialog/confirmbox.js
 ** module id = 12
 ** module chunks = 13 14
 **/